export default __webpack_public_path__ + "static/media/Self-Portrait-2-Nate-Baldwin.3b14acc9.jpg";